const NIELSEN_STATIC_NAME = 'nielsenStatic';

class NielsenStatic {
  constructor() {
    this.name = NIELSEN_STATIC_NAME;
    this.instance = undefined;
    this.metadata = {};
    this._previousArticleMetadata = undefined;
    this.isActive = () => !!this.instance;
  }

  init(config) {
    const { appId, instanceName, sdkDebugEnabled = false } = config;

    this._attributesKeys = {};

    const additionalParams = {
      ...(sdkDebugEnabled && { nol_sdkDebug: 'debug' }),
    };

    this.instance = window.NOLBUNDLE.nlsQ(appId, instanceName, additionalParams);
  }

  // eslint-disable-next-line no-unused-vars
  sendPageViewEvent(params, action, eventFields, attributesByThirdParties) {
    if (!this.instance) {
      return;
    }

    if (this._previousArticleMetadata) {
      this.instance.ggPM('staticend', this._previousArticleMetadata);
      this._previousArticleMetadata = undefined;
    }
    const articleMetadata = eventFields[NIELSEN_STATIC_NAME];

    if (!(NIELSEN_STATIC_NAME in eventFields)) {
      return;
    }

    this._previousArticleMetadata = articleMetadata;
    setTimeout(() => {
      this.instance.ggPM('staticstart', this._previousArticleMetadata);
    }, 100);
  }

  release() {
    this.instance = undefined;
  }
}
export default new NielsenStatic();
